/**
 * @generated SignedSource<<d378146f64cc5ac448022a161198ec9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueSearchInputProvider_jiraFilter$data = {
  readonly isEditable?: boolean | null | undefined;
  readonly jql: string;
  readonly " $fragmentType": "IssueSearchInputProvider_jiraFilter";
};
export type IssueSearchInputProvider_jiraFilter$key = {
  readonly " $data"?: IssueSearchInputProvider_jiraFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSearchInputProvider_jiraFilter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueSearchInputProvider_jiraFilter",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ],
      "type": "JiraCustomFilter"
    }
  ],
  "type": "JiraFilter",
  "abstractKey": "__isJiraFilter"
};

(node as any).hash = "07d892c67fb0e3830707a3d1cccfa800";

export default node;
